import React, { Component, Fragment } from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import HeaderSection from './HeaderSection';
import { connect } from 'react-redux';
import Overlay from '../../Overlay';
import AlertMessages from '../../AlertMessages';

class ApplicationsList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            inpageLoadingPending: true,
            inpageLoadingError: false,
            inpageLoadingSucess: false,
            showInPageAlertModel: false,
            message: '',
        }
    }

    componentDidMount = () => {
        if (this.props.isLoginSuccess === true) {
            this.setState({
                inpageLoadingPending: this.props.isLoginPending,
                inpageLoadingError: this.props.apiError,
                inpageLoadingSucess: this.props.isLoginSuccess,
                showInPageAlertModel: true,
                message: 'Logged-In Successfully',
            })
            setTimeout(() => {
                this.setState({
                    showInPageAlertModel: false,
                })
            }, 2000)
        }
    }

    closeInPageAlertModel = () => {
        this.setState({
            showInPageAlertModel: false,
        })
    }

    render() {
        return (
            <Fragment>
                <ReactCSSTransitionGroup
                    component="div"
                    transitionName="TabsAnimation"
                    transitionAppear={true}
                    transitionAppearTimeout={0}
                    transitionEnter={false}
                    transitionLeave={false}
                >
                    <div>
                        <Fragment>
                            <HeaderSection />
                        </Fragment>
                    </div>
                </ReactCSSTransitionGroup>


                <Overlay
                    openOverlay={this.state.showInPageAlertModel}
                    closeOverlay={this.closeInPageAlertModel}
                    className="alertData"
                >
                    <AlertMessages
                        isSucess={this.state.inpageLoadingSucess}
                        isPending={this.state.inpageLoadingPending}
                        apiError={this.state.inpageLoadingError}
                        showAlert={this.state.showInPageAlertModel}
                        closeAlert={this.closeInPageAlertModel}
                        message={this.state.message}
                    />
                </Overlay>

            </Fragment>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        isLoginSuccess: state.loginData.isLoginSuccess,
        isLoginPending: state.loginData.isLoginPending,
        loginError: state.loginData.loginError,
        authDone: state.loginData.authDone,
        userToken: state.loginData.userToken,
        apiError: state.loginData.apiError,
    };
}

export default connect(mapStateToProps, null)(ApplicationsList);